<ng-container>
    <app-header></app-header>
    <div class="mt-2">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</ng-container>